module.exports = __webpack_public_path__ + "media/usecase_enterprise_07.7788bcfd.mp4";